<template>
  <CPanel>
    <Loading :loading="loading" />
    <div class="row q-mb-sm">
      <span class="text-h6">{{ $t('Settings') }}</span>
    </div>

    <div class="row justify-start full-width">
      <div class="q-my-md col-3">
        <label class="text-no-wrap q-pr-lg" for="filterName"
          >{{ $t('Filter Name') }} <span class="text-red-10">*</span></label
        >
        <input
          maxlength="20"
          v-model="filterNameComputed"
          type="text"
          id="filterName"
          class="form-control"
          style="height: 40px"
        />
      </div>
      <div class="q-my-md col-3 offset-2">
        <label class="text-no-wrap q-pr-lg" for="filterName"
          >{{ $t('Accounts') }} <span class="text-red-10">*</span></label
        >
        <el-select
          :loading="optionsLoading"
          v-model="accountsComputed"
          placeholder="Accounts"
          multiple
          filterable
          @input="accountChangeCallback"
        >
          <el-option
            v-for="(item, index) in accountOptions"
            :label="item"
            :value="item"
            :key="item + index"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row justify-between full-width q-my-md">
      <div class="col-3">
        <Checkbox
          v-model="groupAccountsComputed.value"
          :label="groupAccountsComputed.label"
          color="primary"
        />
      </div>
    </div>
  </CPanel>
</template>
<script>
import CPanel from '@/components/uikit/CPanel';
import Checkbox from '@design-system/components/Checkbox';
import Loading from '@/components/uikit/Loading';

export default {
  components: {
    CPanel,
    Checkbox,
    Loading,
  },
  props: ['filterName', 'accountOptions', 'accounts', 'optionsLoading', 'groupAccounts', 'loading'],
  computed: {
    filterNameComputed: {
      set(val) {
        this.$emit('update:filterName', val);
      },
      get() {
        return this.filterName;
      },
    },
    accountsComputed: {
      set(val) {
        this.$emit('update:accounts', val);
      },
      get() {
        return this.accounts;
      },
    },
    groupAccountsComputed: {
      set(val) {
        this.$emit('update:groupAccounts', {
          value: val,
          label: this.groupAccounts,
        });
      },
      get() {
        return this.groupAccounts;
      },
    },
  },
  methods: {
    accountChangeCallback(val) {
      this.$emit('accountChangeCallback', val);
    },
  },
};
</script>
